// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*styles heading title of page*/
.ai-title-container {
  display: inline;
  margin-top: 15px;
  font-family: "Zilla Slab", serif;
  font-size: 26px;
  color: #fff;
  letter-spacing: 1.5px;
}

/*changes background color for navbar*/
nav {
  background-color: #1976d2;
}

.navbar-expand-lg {
  flex-wrap: wrap;
}


.nav-link {
  align-self: center;
}

.navbar-nav {
  gap: 10px;
}

/*formats navbar links*/
.navbar-nav .nav-link {
  background-color: #1976d2 !important;
  color: white !important;
  font-family: "Lato", sans-serif;
  letter-spacing: 1px;
}

/*styles dropdown items from navbar links*/
.navbar-nav .nav-item {
  font-family: 'Lato', sans-serif;
  letter-spacing: 1px;
}

.navbar-nav .nav-item>a {
  width: fit-content;
  padding: 5px 10px 5px 5px;
  margin: 0;
}

.navbar .nav-link.active {
  border-bottom: .8px solid white;
}

.dropdown-link {
  display: flex;
}

.dropdown-link a {
  width: 100%;
}

.navbar-nav.nav-tabs {
  margin-bottom: -.8px;
}

/*styles background of each dropdown item, only on hover*/
.navbar-nav .nav-item a:hover {
  background-color: black;
  color: white;
}

.navbar .navbar-collapse {
  margin-top: 5px;
}

.navbar-brand {
  white-space: normal;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;

}

.navbar-brand div {
  display: flex;
  justify-content: space-around;
}

button.navbar-toggler {
  background-color: #ddd;
  align-self: center;
}

button.navbar-toggler:focus,
button.navbar-toggler:active,
button.navbar-toggler:visited {
  border: none;
  box-shadow: none;
}

.dropdown-divider {
  margin: 0;
}

.dropdown-menu a {
  padding: 8px 15px;
}

.navbar-nav .dropdown-toggle.nav-link {
  padding: 12px 8px;
}

/************* responsive styless ************/

@media (max-width: 576px) {
  .ai-title-container {
    font-size: 16px;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-basis: none;
  }

  .navbar-brand {
    justify-content: flex-start;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/navBar.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yDAAyD;AACzD;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;;AAEb;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,8CAA8C;;AAE9C;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;AAEF","sourcesContent":["/*styles heading title of page*/\n.ai-title-container {\n  display: inline;\n  margin-top: 15px;\n  font-family: \"Zilla Slab\", serif;\n  font-size: 26px;\n  color: #fff;\n  letter-spacing: 1.5px;\n}\n\n/*changes background color for navbar*/\nnav {\n  background-color: #1976d2;\n}\n\n.navbar-expand-lg {\n  flex-wrap: wrap;\n}\n\n\n.nav-link {\n  align-self: center;\n}\n\n.navbar-nav {\n  gap: 10px;\n}\n\n/*formats navbar links*/\n.navbar-nav .nav-link {\n  background-color: #1976d2 !important;\n  color: white !important;\n  font-family: \"Lato\", sans-serif;\n  letter-spacing: 1px;\n}\n\n/*styles dropdown items from navbar links*/\n.navbar-nav .nav-item {\n  font-family: 'Lato', sans-serif;\n  letter-spacing: 1px;\n}\n\n.navbar-nav .nav-item>a {\n  width: fit-content;\n  padding: 5px 10px 5px 5px;\n  margin: 0;\n}\n\n.navbar .nav-link.active {\n  border-bottom: .8px solid white;\n}\n\n.dropdown-link {\n  display: flex;\n}\n\n.dropdown-link a {\n  width: 100%;\n}\n\n.navbar-nav.nav-tabs {\n  margin-bottom: -.8px;\n}\n\n/*styles background of each dropdown item, only on hover*/\n.navbar-nav .nav-item a:hover {\n  background-color: black;\n  color: white;\n}\n\n.navbar .navbar-collapse {\n  margin-top: 5px;\n}\n\n.navbar-brand {\n  white-space: normal;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  width: 100%;\n\n}\n\n.navbar-brand div {\n  display: flex;\n  justify-content: space-around;\n}\n\nbutton.navbar-toggler {\n  background-color: #ddd;\n  align-self: center;\n}\n\nbutton.navbar-toggler:focus,\nbutton.navbar-toggler:active,\nbutton.navbar-toggler:visited {\n  border: none;\n  box-shadow: none;\n}\n\n.dropdown-divider {\n  margin: 0;\n}\n\n.dropdown-menu a {\n  padding: 8px 15px;\n}\n\n.navbar-nav .dropdown-toggle.nav-link {\n  padding: 12px 8px;\n}\n\n/************* responsive styless ************/\n\n@media (max-width: 576px) {\n  .ai-title-container {\n    font-size: 16px;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-basis: none;\n  }\n\n  .navbar-brand {\n    justify-content: flex-start;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
